import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="202.28545" cy="273.28705" />
				<g className="fill--eyes eyes">
					<ellipse transform="matrix(0.08134 -0.99669 0.99669 0.08134 -107.40938 430.50348)" cx="179.82877" cy="273.51767" rx="7.43675" ry="6.85861" />
					<ellipse transform="matrix(0.99669 -0.08134 0.08134 0.99669 -21.50175 19.20372)" cx="224.95857" cy="273.51767" rx="6.85861" ry="7.43675" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M185.90509,277.65744c-0.11784,0-0.23717-0.0108-0.35724-0.03357l-11.65846-2.20682
						c-1.03592-0.19617-1.71684-1.19516-1.52069-2.23108c0.19614-1.03632,1.19403-1.71613,2.2307-1.52109l11.65846,2.20685
						c1.03592,0.19614,1.71684,1.19516,1.52071,2.23108C187.60553,277.01904,186.80453,277.65744,185.90509,277.65744z" />
					<path d="M218.88225,277.65744c0.11783,0,0.23717-0.0108,0.35724-0.03357l11.65845-2.20682
						c1.03593-0.19617,1.71686-1.19516,1.52071-2.23108c-0.19615-1.03632-1.19403-1.71613-2.23071-1.52109l-11.65845,2.20685
						c-1.03593,0.19614-1.71686,1.19516-1.52071,2.23108C217.18181,277.01904,217.9828,277.65744,218.88225,277.65744z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M185.85614,277.65744c-0.47278,0-0.94632-0.17032-1.3221-0.51553c-0.71872-0.65991-2.27072-1.40652-4.47194-1.52222
						c-2.19969-0.11151-3.82272,0.46475-4.60635,1.04636c-0.86842,0.64426-2.092,0.4621-2.73509-0.40442
						c-0.64388-0.86688-0.46286-2.09161,0.40404-2.73547c1.74753-1.29767,4.34132-1.95947,7.14211-1.81168
						c2.79085,0.14664,5.31056,1.07541,6.91296,2.54797c0.7951,0.73056,0.84779,1.9675,0.11687,2.76257
						C186.91092,277.44473,186.38467,277.65744,185.85614,277.65744z" />
					<path d="M218.92694,277.65744c0.47174,0,0.94426-0.16995,1.31923-0.51443c0.71715-0.65845,2.26578-1.40344,4.4622-1.51889
						c2.1949-0.11127,3.81439,0.46375,4.59633,1.0441c0.86653,0.64285,2.08745,0.46109,2.72914-0.40353
						c0.64247-0.86502,0.46185-2.08707-0.40315-2.72952c-1.74373-1.29486-4.33188-1.95523-7.12657-1.80774
						c-2.78477,0.1463-5.29901,1.07306-6.89793,2.54242c-0.79337,0.72897-0.84595,1.9632-0.11661,2.75656
						C217.87445,277.44519,218.39955,277.65744,218.92694,277.65744z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M218.12268,274.07553c0.37856,4.63864,3.66542,7.16235,7.44078,6.85425c3.77534-0.30811,6.60954-3.3313,6.231-7.96997
						c-0.19713-2.02863-1.23912-3.21503-6.83589-2.69183C218.81996,270.84183,218.08875,271.91293,218.12268,274.07553z" />
					<path d="M186.66464,274.07553c-0.37854,4.63864-3.66541,7.16235-7.44077,6.85425s-6.60956-3.3313-6.231-7.96997
						c0.19713-2.02863,1.23911-3.21503,6.83589-2.69183C185.96736,270.84183,186.69858,271.91293,186.66464,274.07553z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bunny/Eyes.js